<rose-portal-otp-entry-view
    [destinationMasked]="destinationMasked"
    [channel]="'sms'"
    [length]="4"
    [headingLabel]="'OTP_ENTRY.HEADING' | translate:{ destination: destinationMasked }"
    [goBackLabel]="'OTP_ENTRY.GO_BACK' | translate"
    [hasError]="hasError()"
    [errorLabel]="'ERRORS.INVALID_OTP' | translate"
    (codeEntered)="onCodeEntered($event)"
    (goBack)="onGoBack()">
</rose-portal-otp-entry-view>
